export default __webpack_public_path__ + "static/media/chef.0e410daa.png";